// Local fallback renter profiles for the lister "Browse renters" deck.
// Used when the API is offline and @/data/listings mockRenters is unavailable.

const FALLBACK_RENTERS = [
  {
    id: "rent_001",
    name: "Maya Tremblay",
    age: 28,
    photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=900&q=80",
    occupation: "Registered Nurse",
    income_range: "$70k to $85k",
    budget: 2100,
    move_in: "2026-09-01",
    lease_length_wanted: 12,
    pets: "One cat",
    smoking: false,
    household: "Single",
    about:
      "Night shift nurse at Toronto General. Quiet, tidy, and out of the house more than in it. Looking for a bright one bedroom close to transit with in suite laundry.",
    verified: true,
    screening_complete: true,
  },
  {
    id: "rent_002",
    name: "Jordan Osei",
    age: 31,
    photo: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=900&q=80",
    occupation: "Software Developer",
    income_range: "$95k to $110k",
    budget: 2600,
    move_in: "2026-08-15",
    lease_length_wanted: 24,
    pets: "No pets",
    smoking: false,
    household: "Couple",
    about:
      "Remote developer moving to Vancouver with my partner. We cook a lot, keep to ourselves, and want a long term home. Excellent references from our last two landlords.",
    verified: true,
    screening_complete: true,
  },
  {
    id: "rent_003",
    name: "Sophie Lavoie",
    age: 25,
    photo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=900&q=80",
    occupation: "Graduate Student, McGill",
    income_range: "$35k to $45k",
    budget: 1400,
    move_in: "2026-09-01",
    lease_length_wanted: 12,
    pets: "No pets",
    smoking: false,
    household: "Single",
    about:
      "PhD candidate in neuroscience with guaranteed funding for four more years. Looking for a studio or small one bedroom near the Plateau. Parents happy to cosign.",
    verified: true,
    screening_complete: false,
  },
  {
    id: "rent_004",
    name: "Daniel Whitehorse",
    age: 37,
    photo: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=900&q=80",
    occupation: "Electrician, Red Seal",
    income_range: "$80k to $95k",
    budget: 2300,
    move_in: "2026-10-01",
    lease_length_wanted: 18,
    pets: "One dog, trained lab",
    smoking: false,
    household: "Family of three",
    about:
      "Moving to Calgary for a long term contract. Wife works in childcare, one kid in grade two. We treat every rental like our own place and can share proof of income.",
    verified: true,
    screening_complete: true,
  },
  {
    id: "rent_005",
    name: "Priya Sharma",
    age: 29,
    photo: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=900&q=80",
    occupation: "Financial Analyst",
    income_range: "$85k to $100k",
    budget: 2400,
    move_in: "2026-08-01",
    lease_length_wanted: 12,
    pets: "No pets",
    smoking: false,
    household: "Single",
    about:
      "Analyst at a big five bank, relocating to Ottawa. Nonsmoker, no parties, mostly at the office or the gym. Can provide an employment letter and credit report on day one.",
    verified: true,
    screening_complete: true,
  },
  {
    id: "rent_006",
    name: "Liam Gallagher-Roy",
    age: 34,
    photo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=900&q=80",
    occupation: "High School Teacher",
    income_range: "$65k to $80k",
    budget: 1900,
    move_in: "2026-09-01",
    lease_length_wanted: 24,
    pets: "Two cats",
    smoking: false,
    household: "Couple",
    about:
      "Permanent teaching position in Halifax. My partner is a paramedic. Stable income, quiet evenings, and two very lazy cats. Looking for a two bedroom we can settle into.",
    verified: false,
    screening_complete: false,
  },
];

export default FALLBACK_RENTERS;
